<template>
    <div>
        <a-card>
            <a-form :form="form" class="custom pick-100 form-input about">
                <a-row>
                    <a-col :span="24">
                        <a-divider class="color-orange mt-6" orientation="left">供应商信息</a-divider>
                    </a-col>

                    <table style="width:100%" class="fx-form">
                        <tr>
                            <th>供应商名称:</th>
                            <td>
                                <a-form-item>
                                    <a-input
                                            size="large"
                                            style="color: black;font-weight: bold"
                                            disabled
                                            v-decorator="['supplierName',{initialValue:supplier.supplierName}]"
                                    />
                                </a-form-item>
                            </td>
                            <th>
                                <span v-if="supplier.supplierType === '2'">统一社会信用代码:</span>
                                <span v-else-if="supplier.supplierType === '1' && supplier.natureType === '2'">注册号:</span>
                                <span v-else-if="supplier.supplierType === '1' && supplier.natureType === '1'">身份证号:</span>
                            </th>
                            <td>
                                <a-form-item>
                                    <a-input
                                            v-if="supplier.supplierType === '2'"
                                            size="large"
                                            style="color: black;font-weight: bold"
                                            disabled
                                            v-decorator="['supplierCode',{initialValue:supplier.supplierCode}]"
                                    />
                                    <a-input
                                            v-if="supplier.supplierType === '1'"
                                            size="large"
                                            style="color: black;font-weight: bold"
                                            disabled
                                            v-decorator="['supplierCode',{initialValue:supplier.legalIdCard}]"
                                    />
                                </a-form-item>
                            </td>
                        </tr>
                        <tr>
                            <th class="not-null">联系人:</th>
                            <td>
                                <a-form-item>
                                    <a-input
                                            size="large"
                                            v-decorator="['contacts',{initialValue:account.nickname, rules: [{ required: true, message: '联系人不能为空'}]}]"
                                    />
                                </a-form-item>
                            </td>
                            <th class="not-null">联系人手机号:</th>
                            <td>
                                <a-form-item>
                                    <a-input
                                            size="large"
                                            v-decorator="['contactsPhone',{initialValue:account.phone ,rules: [{type: 'string',message: '输入正确的手机号', required: true, pattern: /^[1][3-9][0-9]{9}$/ }]}]"
                                    />
                                </a-form-item>
                            </td>
                        </tr>
                        <tr>
                            <th class="not-null">电子邮件:</th>
                            <td>
                                <a-form-item>
                                    <a-input
                                            size="large"
                                            v-decorator="['supplierEmail',{initialValue:supplier.email, rules: [{ required: true, message: '邮箱不能为空'},{type: 'email',message: '邮箱不符合规范'}]}]"
                                    />
                                </a-form-item>
                            </td>

                            <th>办公电话:</th>
                            <td>
                                <a-form-item>
                                    <a-input
                                            size="large"
                                            v-decorator="['mobile',{initialValue:supplier.mobile, rules: [{type: 'string',message: '请输入正确的电话号码', required: false, pattern: /\d{3}-\d{8}|\d{4}-\d{7,8}/ }]}]"
                                    />
                                </a-form-item>
                            </td>
                        </tr>
                    </table>
                </a-row>
                <a-row class="mt-6">
                    <a-col :span="6" :offset="9">
                        <a-button align="right" type="primary" size="large" :loading="loading" @click="onSubmit"
                                  block>确认报名
                        </a-button>
                    </a-col>
                </a-row>
            </a-form>
        </a-card>
        <a-divider/>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'
    import {PageView} from '@/layouts'
    import STable from '@/components/Table'
    import moment from 'moment'
    import 'vue-area-linkage/dist/index.css'
    import {pca, pcaa} from 'area-data'
    import UploadSelector from '../../components/selector/UploadSelector'

    export default {
        props: ['projectId'],
        created() {
            this.loadData()
        },
        components: {
            PageView,
            STable,
            moment,
            UploadSelector
        },
        name: 'Step1',
        data() {
            return {
                labelCol: {lg: {span: 5}, sm: {span: 5}},
                wrapperCol: {lg: {span: 19}, sm: {span: 19}},
                form: this.$form.createForm(this),
                supplier: {},
                loading: false,
                data: [],
                project: {},
                account: '',
            }
        },
        methods: {
            nextStep() {
                const {form: {validateFields}} = this
                // 先校验，通过表单校验后，才进入下一步
                validateFields((err, values) => {
                    if (!err) {
                        return
                    }
                    this.$emit('nextStep')
                })
            },
            loadData() {
                if (!this.projectId) {
                    this.error('项目ID数据异常!')
                    return
                }
                let url = '/api/1/demandSign/getDemandProjectDetails.json?projectId=' + this.projectId
                this.$http.get(url).then(res => {
                    this.supplier = res.supplier
                    this.account = res.account
                    this.project = res.project
                })
            },
            error(val) {
                this.$error({
                    title: '提示',
                    content: val
                })
            },
            onSubmit() {
                this.form.validateFields((err, values) => {
                    if (err) {
                        return
                    }
                    let that = this
                    let params = this.form.getFieldsValue()
                    params.projectId = this.projectId
                    this.loading = true
                    this.$http.post('/api/1/demandSign/demandSupplierSign.json', qs.stringify(params)).then(function (res) {
                        that.loading = false
                        if (res.code !== 200) {
                            that.$message.error("报名失败")
                        }
                        that.$emit('finish')
                    })
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .step-form-style-desc {
        padding: 0 56px;
        color: rgba(0, 0, 0, .45);

        h3 {
            margin: 0 0 12px;
            color: rgba(0, 0, 0, .45);
            font-size: 16px;
            line-height: 32px;
        }

        h4 {
            margin: 0 0 4px;
            color: rgba(0, 0, 0, .45);
            font-size: 14px;
            line-height: 22px;
        }

        p {
            margin-top: 0;
            margin-bottom: 12px;
            line-height: 22px;
        }
    }

    /deep/ .ant-form-item-label label {
        color: #8c8c8c;
    }

    /deep/ .ant-form-item-children {
        color: #000;
        font-weight: bold;
    }

    .register-title {
        position: relative;
    }

    .register-title img {
        margin: auto;
    }

    .register-title p {
        position: absolute;
        top: 10px;
        font-size: 20px;
        color: #fff;
        width: 100%;
        text-align: center;
    }

    .ant-input {
        width: 100%;
    }

    th {
        width: 125px;
    }

    tr {
        height: 65px;
    }

    .ant-table-thead > tr > th {
        font-weight: bold;
    }
</style>
